import cookies from "js-cookie";

import { ErrorService } from "@/services/errorService";
import { UserInfo } from "@/api";
import { Store } from "@/store";

export class AuthService {
  private cookieId = "auth-session";
  // 5 minute window
  private sessionExpiryWindowMS = 240000;

  public async startPasswordlessLogin(email: string): Promise<boolean> {
    const returnTo = encodeURIComponent(window.location.pathname + window.location.search);

    try {
      const res = await fetch(`/auth/otp/login?returnTo=${returnTo}`, {
        body: JSON.stringify({ email }),
        method: "POST",
      });
      return res.ok;
    } catch (error) {
      ErrorService.report(error);
      console.error("error", error);
      return false;
    }
  }

  public async verifyPasswordlessCode(email: string, code: string): Promise<boolean> {
    try {
      const res = await fetch(`/auth/otp/verify`, {
        body: JSON.stringify({ email, code }),
        method: "POST",
      });
      return res.ok;
    } catch (error) {
      ErrorService.report(error);
      console.error("error", error);
      return false;
    }
  }

  public async getUser(): Promise<UserInfo | undefined> {
    const user = Store.user.info.peek();

    if (user && this.willSessionExpire(user)) {
      this.login(window.location.href);
      return undefined;
    }

    if (user) {
      return Store.user.info.value;
    }

    return undefined;
  }

  public login(returnPath: string): void {
    const loginUrl = `/login?returnTo=${encodeURIComponent(returnPath)}`;
    window.location.assign(loginUrl);
  }

  public logout(): void {
    Store.user.info.value = undefined;
    Store.user.isLoggedIn.value = false;
    cookies.remove(this.cookieId);
    window.location.reload();
  }

  private willSessionExpire(user: UserInfo): boolean {
    if (!user.exp) {
      return false;
    }
    return user?.exp >= Date.now() + this.sessionExpiryWindowMS;
  }
}
